import { jsx as f } from '../../jsx-runtime'
import type { LinkProps } from '../types'

// Import the navigate function getter, not the function itself
// This ensures we always use the current navigate implementation
import { getNavigate } from '../router'

export function Link(props: LinkProps) {
    return f('a', {
        href: props.to,
        class: props.class || props.className,
        style: props.style ? props.style + '; cursor: pointer;' : 'cursor: pointer;',
        onclick: (event: Event) => {
            event.preventDefault()
            // Get current navigate function at click time
            getNavigate()(props.to)
        },
        children: props.children
    })
}
